import { http } from './http'

export function getMe () {
  return http.get('/api/me')
}

export function changePassword (current_password, new_password) {
  return http.put('/api/me/password', {
    current_password,
    new_password
  })
}

export function updateMealVisibility (payload) {
  return http.put('/api/me/meal-visibility', payload)
}
